import React, { useEffect, useState } from 'react';
import './matchup-item.styles.scss';

import { faLock, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import streak_bonus from '@/assets/streak-bonus.png';
import { formatNumber } from '@/utils/formatNumber';
import questionmark from '@/assets/questionmark.png';
import { categories } from '@/utils/matchup-categories';
import tie_icon from '@/assets/tie-icon.png';

export function getPercentages(picks, matchup) {
  // if (!picks) return [0,0,0,0];
  let obj = {}
  for (let i of [1, 2, 3, 4, 5]) {
    if (!matchup[`comp${i}`]) continue;
    if (!picks || Object.values(picks).length === 0) {
      obj[`c${i}`] = 0;
      obj[`w${i}`] = 0;
      continue;
    }
    obj[`c${i}`] = Number((Object.values(picks)
      .filter(p => p.pick === `comp${i}`).length /
      Object.values(picks).length * 100).toFixed(0));

    obj[`w${i}`] = Number(Object.values(picks)
      .filter(p => p.pick === `comp${i}`)
      .reduce((acc, p) => acc + p.wager, 0))
  }
  if (matchup.allowTie) {
    if (!picks || Object.values(picks).length === 0) {
      obj.cTie = 0;
      obj.wTie = 0;
    } else {
      obj.cTie = Number((Object.values(picks)
        .filter(p => p.pick === 'tie').length /
        Object.values(picks).length * 100).toFixed(0));
      obj.wTie = Number(Object.values(picks)
        .filter(p => p.pick === 'tie')
        .reduce((acc, p) => acc + p.wager, 0));
    }
  }
  return obj;
}

export const MatchupItem = ({
  matchup
}) => {

  const currentGame = useSelector(state => state.gameData.currentGame);
  const userProfile = useSelector(state => state.userData.profile);
  const [pick, setPick] = useState({});
  const [percentages, setPercentages] = useState({});

  useEffect(() => {
    if (!matchup) return;
    setPick(matchup.picks && matchup.picks[userProfile.appId] ? matchup.picks[userProfile.appId] : {})
    setPercentages(getPercentages(matchup.picks, matchup));
  }, [matchup])

  return (
    <div className={`g-box matchup-item ${(matchup.comp1 && matchup.comp2) ? 'clickable' : ''}`}>
      {
        matchup.allowTie
          ?
          <div className='item-content three-way'>
            <div className='desc-div'>
              <div className='category'>{
                (categories && categories[matchup.category]) &&
                <>
                  <img src={categories[matchup.category].icon} />
                  {categories[matchup.category].title}
                </>
              }</div>
              <div className='g-space-0-5'></div>
              <div className='desc-title'>{matchup.name}</div>
              <div className='desc-date'>
                {format(new Date(matchup.date), "E, Pp")}
              </div>
              {
                (pick.wager) &&
                <div><b>Wager: {pick.wager}</b></div>
              }
              {
                (matchup.date < new Date().getTime())
                  ?
                  <div className='center-col'>
                    <FontAwesomeIcon icon={faLock} />
                  </div>
                  :
                  (!matchup.penalty)
                    ?
                    <div className='center-col category'>
                      (Optional)
                    </div>
                    : null
              }
            </div>
            <div className='options-row'>
              <div className={`img-div ${pick.pick === 'comp1' ? 'picked' : ''}`}>
                <img src={matchup.comp1Icon ?? questionmark} className='matchup-icon' loading="lazy" />
                {
                  (matchup.comp1) &&
                  <div className={`pick-percentage ${percentages.c1 >= 50 ? 'high' : 'low'}`}>
                    {`${percentages.c1}%`}
                  </div>
                }
              </div>
              <div className={`img-div tie-option ${pick.pick === 'tie' ? 'picked' : ''}`}>
                <img src={tie_icon} className='matchup-icon' loading="lazy" />
                <div className={`pick-percentage ${(percentages.cTie ?? 0) >= 50 ? 'high' : 'low'}`}>
                  {`${percentages.cTie ?? 0}%`}
                </div>
              </div>
              <div className={`img-div ${pick.pick === 'comp2' ? 'picked' : ''}`}>
                <img src={matchup.comp2Icon ?? questionmark} className='matchup-icon' loading="lazy" />
                {
                  (matchup.comp2) &&
                  <div className={`pick-percentage ${percentages.c2 >= 50 ? 'high' : 'low'}`}>
                    {`${percentages.c2}%`}
                  </div>
                }
              </div>
            </div>
          </div>
          :
          <div className='item-content'>
            <div className={`img-div ${pick.pick === 'comp1' ? 'picked' : ''}`}>
              <img src={matchup.comp1Icon ?? questionmark} className='matchup-icon' loading="lazy" />
              {
                (matchup.comp1) &&
                <div className={`pick-percentage ${percentages.c1 >= 50 ? 'high' : 'low'}`}>
                  {`${percentages.c1}%`}
                </div>
              }
            </div>
            <div className='desc-div'>
              <div className='category'>{
                (categories && categories[matchup.category]) &&
                <>
                  <img src={categories[matchup.category].icon} />
                  {categories[matchup.category].title}
                </>
              }</div>
              <div className='g-space-0-5'></div>
              <div className='desc-title'>{matchup.name}</div>
              <div className='desc-date'>
                {format(new Date(matchup.date), "E, Pp")}
              </div>
              {
                (pick.wager) &&
                <div>
                  <b>Wager: {pick.wager}</b>
                </div>
              }
              {
                (matchup.date < new Date().getTime())
                  ?
                  <div className='center-col'>
                    <FontAwesomeIcon icon={faLock} />
                  </div>
                  :
                  (!matchup.penalty)
                    ?
                    <div className='center-col category'>
                      (Optional)
                    </div>
                    : null
              }
            </div>
            <div className={`img-div ${pick.pick === 'comp2' ? 'picked' : ''}`}>
              <img src={matchup.comp2Icon ?? questionmark} className='matchup-icon' loading="lazy" />
              {
                (matchup.comp2) &&
                <div className={`pick-percentage ${percentages.c2 >= 50 ? 'high' : 'low'}`}>
                  {`${percentages.c2}%`}
                </div>
              }
            </div>
          </div>
      }
    </div>
  )
}

export const PassedMatchupItem = ({ matchup }) => {

  const userProfile = useSelector(state => state.userData.profile);
  const [pick, setPick] = useState({});
  const [pick1Bg, setPick1Bg] = useState('');
  const [pick2Bg, setPick2Bg] = useState('');
  const [tieBg, setTieBg] = useState('');
  const [percentages, setPercentages] = useState({});

  useEffect(() => {
    if (!matchup || matchup.bonus) return;
    setPick(matchup.picks && matchup.picks[userProfile.appId] ? matchup.picks[userProfile.appId] : {})
    setPercentages(getPercentages(matchup.picks, matchup));
  }, [matchup])

  useEffect(() => {
    if (!pick.pick || !matchup) return;
    setPick1Bg('');
    setPick2Bg('');
    setTieBg('');
    if (matchup.winner) {
      if (matchup.winner === 'comp1') {
        setPick1Bg('comp-winner');
      } else if (matchup.winner === 'comp2') {
        setPick2Bg('comp-winner');
      } else if (matchup.winner === 'tie') {
        setTieBg('comp-winner');
      }
      if (matchup.winner === 'tie') {
        if (pick.pick === 'tie') {
          setTieBg('picked-correct');
          // setPick1Bg('');
          // setPick2Bg('');
        } else {
          // setTieBg('');
          setPick1Bg(pick.pick === 'comp1' ? 'picked-wrong' : '');
          setPick2Bg(pick.pick === 'comp2' ? 'picked-wrong' : '');
        }
      } else if (pick.pick === matchup.winner) {
        // setTieBg('');
        if (matchup.winner === 'comp1') {
          setPick1Bg('picked-correct');
          // setPick2Bg('');
        } else {
          // setPick1Bg('');
          setPick2Bg('picked-correct');
        }
      } else {
        // setTieBg('');
        if (matchup.winner === 'comp1') {
          // setPick1Bg('');
          setPick2Bg('picked-wrong');
        } else {
          setPick1Bg('picked-wrong');
          // setPick2Bg('');
        }
      }
    } else if (pick.pick === 'comp1') {
      setPick1Bg('picked');
      // setPick2Bg('');
      // setTieBg('');
    } else if (pick.pick === 'comp2') {
      // setPick1Bg('');
      setPick2Bg('picked');
      // setTieBg('');
    } else if (pick.pick === 'tie') {
      // setPick1Bg('');
      // setPick2Bg('');
      setTieBg('picked');
    }
  }, [pick, matchup])

  if (matchup.bonus) {
    return (
      <div className='g-box bonus-box'>
        <img src={streak_bonus} loading="lazy" />
        <div className='bonus-data'>
          <div className='title'>Streak Bonus!</div>
          <div className='meta'>{matchup.streak} in a Row</div>
          <div className='result-pts'>+{matchup.earned}</div>
        </div>
        <img src={streak_bonus} />
      </div>
    )
  }

  return (
    <div className='g-box matchup-item '>
      <div className='item-content passed'>
        <div className='category'>{
          (categories && categories[matchup.category]) &&
          <>
            <img src={categories[matchup.category].icon} />
            {categories[matchup.category].title}
          </>
        }</div>

        <div className='desc-title'>{matchup.name}</div>
        <div className='desc-date'>
          {format(new Date(matchup.date), "E, Pp")}
        </div>
        {
          (matchup.winner)
            ?
            <div className='result'>Result: {
              pick.pick === matchup.winner 
              ? <span className='win'>+{pick.wager}</span> 
              : <span className='loss'>-{pick.wager}</span>
            }</div>
            :
            (pick.wager)
              ?
              <div className='wager'>Wager: {pick.wager}</div>
              :
              null
        }
        <div className={`details ${matchup.allowTie ? 'three-way' : ''}`}>
          <div className={`img-div ${pick1Bg}`}>
            <img src={matchup.comp1Icon} className='passed-matchup-icon' loading="lazy" />
            {
              (matchup.comp1Details) &&
              <div className='comp-details'>{matchup.comp1Details}</div>
            }
          </div>
          {
            matchup.allowTie &&
            <div className={`img-div ${tieBg}`}>
              <img src={tie_icon} className='passed-matchup-icon' loading="lazy" />
            </div>
          }
          <div className={`img-div ${pick2Bg}`}>
            <img src={matchup.comp2Icon} className='passed-matchup-icon' loading="lazy" />
            {
              (matchup.comp2Details) &&
              <div className='comp-details'>{matchup.comp2Details}</div>
            }
          </div>
          <div className={`pick-percentage ${percentages.c1 >= 50 ? 'high' : 'low'}`}>
            {`${percentages.c1}%`}
            <div className='meta'>Tot Wager: {formatNumber(percentages.w1)}</div>
          </div>
          {
            matchup.allowTie &&
            <div className={`pick-percentage ${(percentages.cTie ?? 0) >= 50 ? 'high' : 'low'}`}>
              {`${percentages.cTie ?? 0}%`}
              <div className='meta'>Tot Wager: {formatNumber(percentages.wTie ?? 0)}</div>
            </div>
          }
          <div className={`pick-percentage ${percentages.c2 >= 50 ? 'high' : 'low'}`}>
            {`${percentages.c2}%`}
            <div className='meta'>Tot Wager: {formatNumber(percentages.w2)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}